// extracted by mini-css-extract-plugin
export default {"box":"confirm-order_box__fEGuK","btn":"confirm-order_btn__sYojN","btnIcon":"confirm-order_btnIcon__TtPSd","select":"confirm-order_select__k7-p6"};